module.exports = __webpack_public_path__ + "static/banner-7eb3bc6998e8c8c0d81c1761c4f81f2a.png";